// extracted by mini-css-extract-plugin
module.exports = {"list":"menu_list__30kqm","listItem":"menu_listItem__2wHhF","arrow":"menu_arrow__QIjlz","link":"menu_link__2GZjr"};